import { render, staticRenderFns } from "./MultiTags.vue?vue&type=template&id=142bd6ea&scoped=true"
import script from "./MultiTags.vue?vue&type=script&lang=js"
export * from "./MultiTags.vue?vue&type=script&lang=js"
import style0 from "./MultiTags.vue?vue&type=style&index=0&id=142bd6ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142bd6ea",
  null
  
)

export default component.exports